import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import MUIAvatar from '@mui/material/Avatar';
import Initial from '../Icons/Initial';

const baseAvatarPropertyTypes = {
  src: PropTypes.string,
  children: PropTypes.node,
  alt: PropTypes.string,
};

const BaseAvatar = ({ ...properties }) => <MUIAvatar {...properties} />;
BaseAvatar.propTypes = baseAvatarPropertyTypes;

BaseAvatar.defaultProps = {
  src: undefined,
  children: undefined,
  alt: undefined,
};

interface StyledAvatarProperties {
  border?: number;
  size?: number;
}

const StyledAvatar = styled(BaseAvatar)<StyledAvatarProperties>`
  && {
    ${({ border, size, theme }) => css`
      width: ${size}px;
      height: ${size}px;
      font-size: ${size && size - (size / 6)}px;
      ${border && css`
        border: solid ${theme.colors.white} ${border}px;
      `}
    `}
    color: ${({ theme }) => theme.colors.white};
  }
  /* stylelint-disable-next-line selector-type-no-unknown */
  progressive-img {
    ${({ size }) => css`
      width: ${size}px;
      height: ${size}px;
      ${size && css`
      --placeholder-filter: blur(${Math.floor(size / 24) + 1}px) saturate(1.2);
      `}
    `}
  }
`;

const avatarPropertyTypes = {
  size: PropTypes.number,
  border: PropTypes.number,
  name: PropTypes.string,
  image: PropTypes.node,
};

type AvatarPropertiesFromPropertyTypes = InferProps<typeof avatarPropertyTypes>;
interface AvatarPropertiesOverrides {
  size?: number;
  border?: number;
}
// eslint-disable-next-line max-len
type AvatarProperties = AvatarPropertiesFromPropertyTypes & AvatarPropertiesOverrides;

const Avatar = ({
  name,
  image,
  size,
  border,
  ...properties
}: AvatarProperties) => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const initial = name?.toString().charAt(0).toLowerCase() || 'f';

  return (
    <StyledAvatar
      size={size}
      border={border}
      {...properties}
    >
      {/* eslint-disable-next-line max-len */}
      {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
      {image || (
        <Initial
          size={size}
          letter={initial}
        />
      )}
    </StyledAvatar>
  );
};

Avatar.propTypes = avatarPropertyTypes;

Avatar.defaultProps = {
  name: undefined,
  image: undefined,
  size: 24,
  border: 0,
};

export {
  BaseAvatar as default,
  Avatar,
};
